var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshCw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "refresh-cw-03"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M14.333 22C14.333 22 15.1823 21.8787 18.697 18.364C22.2117 14.8492 22.2117 9.15076 18.697 5.63604C17.4517 4.39077 15.9323 3.58669 14.333 3.22383M14.333 22H20.333M14.333 22L14.333 16M10.333 2.00019C10.333 2.00019 9.48377 2.12152 5.96905 5.63624C2.45433 9.15095 2.45433 14.8494 5.96905 18.3642C7.21432 19.6094 8.73373 20.4135 10.333 20.7764M10.333 2.00019L4.33301 2M10.333 2.00019L10.333 8",
    stroke: "#145DD7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshCw);
export default __webpack_public_path__ + "static/media/refresh-cw.8c971e9e23e819402ba51b4ef75d7cca.svg";
export { ForwardRef as ReactComponent };